module.exports = __webpack_public_path__ + "static/media/Internationalcase4.4fd4d6c2.png";